export default {
  ANALOG: "analog",
  SETTING: "setting",
  ALARM: "alarm",
  IOTALART: "iotalart",
  CLOUDALART: "cloudalart",
  PROCESS: "process",
  OPERATION: "operation",
  NOTIFY: "notify",
  NOTIFY_AI: "notify_ai",
  SAIIK: "saiik",
}
